module.exports = __webpack_public_path__ + "static/media/entregachips2.36542789.webp";